import { createContext } from 'react';

const ActionsGroupContext = createContext();

export default ActionsGroupContext;
